import React from "react";
import { ReactComponent as REACT } from "../img/skill_icons/react.svg";

export const ReactIcon = () => {
  return <REACT title="react" />;
};
